import { connect } from 'react-redux';
import EditTtn from './EditTtn';
import {
  addPieceToTn,
  confirmTn,
  deletePieceFromTn,
  deleteTn,
  getTnList,
  getTnPieceList,
  modalTNOpen,
  setInitialStateTn,
  setTn
} from '../../store/actions/tn';
import { getPiecesByStock } from '../../store/actions/documents';

const mapStateToProps = ({
  tnReducer,
  tabsReducer,
  documentsReducer
}) => ({
  tnReducer,
  tabsReducer,
  documentsReducer
});

const mapDispatchToProps = {
  addPieceToTn,
  confirmTn,
  deletePieceFromTn,
  deleteTn,
  getPiecesByStock,
  getTnList,
  getTnPieceList,
  modalTNOpen,
  setInitialStateTn,
  setTn
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditTtn);
